module.exports = __webpack_public_path__ + "static/img/banner_wap.3b201d95.png";